<script setup>
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  }
});
</script>

<template>
  <div
    v-if="
      data?.title ||
      data?.columns?.left ||
      data?.columns?.right ||
      (data?.items && data?.items.length > 0)
    "
    class="catalog__prices"
  >
    <p
      v-if="data.title"
      class="mb-0 h5 catalog__prices-title"
      v-html="data.title"
    ></p>
    <div
      v-if="
        data?.columns?.left ||
        data?.columns?.right ||
        (data?.items && data?.items.length > 0)
      "
      class="catalog__prices-wrap"
    >
      <table class="catalog__prices-table label">
        <thead
          v-if="data?.columns?.left || data?.columns?.right"
          class="catalog__prices-table-top"
        >
          <tr>
            <th
              v-if="data?.columns?.left"
              class="catalog__prices-table-top-cell"
              v-html="data.columns.left"
            ></th>
            <th
              v-if="data?.columns?.right"
              class="catalog__prices-table-top-cell"
              v-html="data.columns.right"
            ></th>
          </tr>
        </thead>
        <tbody v-if="data?.items && data?.items.length > 0">
          <tr
            v-for="(item, itemIndex) in data.items"
            :key="itemIndex"
            class="catalog__prices-table-row"
          >
            <td
              v-if="item.title && item.title.length > 0"
              class="catalog__prices-table-cell"
            >
              <CTagDetect
                v-if="item.url && item.url.length > 0"
                :to="item.url"
                class="m-0 p-0 catalog__prices-item-title"
              >
                <p class="m-0 p-0" v-html="item.title"></p>
              </CTagDetect>
              <p
                v-else
                class="m-0 p-0 catalog__prices-item-title"
                v-html="item.title"
              ></p>
            </td>
            <td
              v-if="item.price && item.price.length > 0"
              class="catalog__prices-table-cell">
              <p class="m-0 p-0 catalog__prices-item-price" v-html="item.price"></p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped lang="scss">
.catalog__prices {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  text-align: left;
  @include media-breakpoint-up(md) {
    gap: 24px;
    padding: 24px 48px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(padding-top, 24);
    @include responsive-spacing(padding-bottom, 24);
    @include responsive-spacing(padding-right, 48);
    @include responsive-spacing(padding-left, 48);
    @include responsive-spacing(gap, 24);
  }
  &-table {
    width: 100%;
    &-top {
      color: $on-surface-variant;
      &-cell {
        padding: 8px 8px 8px 0;
        &:nth-child(2){
          padding-left: 8px;
          padding-right: 0;
          text-align: right;
        }
        @include media-breakpoint-up(md) {
          padding: 16px 16px 16px 0;
          &:nth-child(2){
            padding-left: 16px;
            padding-right: 0;
          }
        }
        @include media-breakpoint-up(xl) {
          @include responsive-spacing(padding-top, 16);
          @include responsive-spacing(padding-right, 16);
          @include responsive-spacing(padding-bottom, 16);
          &:nth-child(2){
            @include responsive-spacing(padding-left, 16);
          }
        }
      }
    }
    &-row {
      border-bottom: 1px solid $divider;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(border-bottom-width, 1);
      }
    }
    &-cell {
      padding: 8px 8px 8px 0;
      &:nth-child(2) {
        padding-left: 8px;
        padding-right: 0;
        text-align: right;
      }
      @include media-breakpoint-up(md) {
        padding: 16px 16px 16px 0;
        &:nth-child(2){
          padding-left: 16px;
          padding-right: 0;
        }
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(padding-top, 16);
        @include responsive-spacing(padding-right, 16);
        @include responsive-spacing(padding-bottom, 16);
        &:nth-child(2){
          @include responsive-spacing(padding-left, 16);
        }
      }
    }
  }
}
</style>